const PENDING_EMAIL_CHANGE_REDIRECT_KEY = 'pending_email_change_redirect'

export function isEmailChangeCurrentConfirmationRoute(path, query = {}) {
  return path === '/profile'
    && query.emailChangeAction === 'confirm-current'
    && Boolean(query.emailChangeToken || query.token)
    && Boolean(query.email)
}

export function rememberPendingEmailChangeRedirect(fullPath) {
  try {
    sessionStorage.setItem(PENDING_EMAIL_CHANGE_REDIRECT_KEY, fullPath)
    localStorage.setItem(PENDING_EMAIL_CHANGE_REDIRECT_KEY, fullPath)
  } catch (error) {
    console.warn('保存邮箱更改跳转失败:', error)
  }
}

export function consumePendingEmailChangeRedirect() {
  try {
    const redirect = peekPendingEmailChangeRedirect()
    if (redirect) {
      sessionStorage.removeItem(PENDING_EMAIL_CHANGE_REDIRECT_KEY)
      localStorage.removeItem(PENDING_EMAIL_CHANGE_REDIRECT_KEY)
    }
    return redirect
  } catch (error) {
    console.warn('读取邮箱更改跳转失败:', error)
    return ''
  }
}

export function peekPendingEmailChangeRedirect() {
  try {
    return sessionStorage.getItem(PENDING_EMAIL_CHANGE_REDIRECT_KEY)
      || localStorage.getItem(PENDING_EMAIL_CHANGE_REDIRECT_KEY)
      || ''
  } catch (error) {
    console.warn('读取邮箱更改跳转失败:', error)
    return ''
  }
}

export function getCurrentEmailChangeRedirectFromLocation() {
  try {
    const url = new URL(window.location.href)
    if (url.pathname !== '/profile') return ''
    const emailChangeAction = url.searchParams.get('emailChangeAction')
    const token = url.searchParams.get('emailChangeToken') || url.searchParams.get('token')
    const email = url.searchParams.get('email')
    if (emailChangeAction !== 'confirm-current' || !token || !email) return ''
    return `${url.pathname}${url.search}`
  } catch (error) {
    console.warn('解析邮箱更改跳转失败:', error)
    return ''
  }
}
